import React, { Component } from 'react'

// @material-ui/core components
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Typography from "@material-ui/core/Typography";

// @material-ui/icons
import FiberManualRecord from "@material-ui/icons/FiberManualRecord";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";


import _ from "lodash";

import style from "./DXFormStyles";

export default class DXFormInputLikert extends Component {
  render() {
    const {
      pid,
      question,
      valueState,
      setFormValueState,
      classes,
    } = this.props;

    const id = `${pid}.${question.id}`;

    const { titleStyle = { sm: 2 } } = question;
    const { sm } = titleStyle;

    const error = _.get(valueState, `${id}State`) === 'error';

    return <GridContainer key={id} justify='center'>
      <GridItem xs={12} sm={sm}>
        <h4 style={style.infoText}>
          {
            error
              ? <span className={classes.required}>필수</span>
              : null
          }
          {question.title}
        </h4>
      </GridItem>
      <GridItem xs={12} sm={12 - sm}>
        {
          question.options.map(({ title, value }) => <FormControlLabel
            key={value}
            control={
              <Radio
                disabled={setFormValueState === null}
                checked={_.get(valueState, id) === value}
                onChange={e => {
                  setFormValueState(id, value);
                  setFormValueState(`${id}State`, 'success')
                }}
                value={value}
                name="radio button"
                aria-label={title}
                icon={
                  <FiberManualRecord
                    style={style.radioUnchecked}
                  />
                }
                checkedIcon={
                  <FiberManualRecord
                    style={style.radioChecked}
                  />
                }
              />
            }
            label={<Typography className={classes.inputSelectionExampleText}>{title}</Typography>}
          />
          )
        }
      </GridItem>
    </GridContainer >
  }
}
